'use strict';

define('UserProfileSvc',[ 'lodash', 'PreferencesEntityBuilder' ], function (_, PreferencesEntityBuilder) {

    function UserProfileSvc(
        $http,
        $q,
        $rootScope,
        poller,
        $filter,
        ConfigurationFac,
        PreferencesCookieFac,
        PreferencesFac
    ) {

        var balancePoller = null;

        var BalanceFac = {
            pollBalance: function (forceUpdate) {

                if(!balancePoller || forceUpdate) {
                    balancePoller = poller.get(BalanceFac, {
                        action: 'getAccountBalance',
                        delay: 120000,
                        argumentsArray: [
                            {}
                        ]
                    });
                }

                return balancePoller;
            },

            stopPollingBalance: function (deferred) {
                if (balancePoller) {
                    balancePoller.removeDeferred(deferred);
                    balancePoller = null;
                }
            },

            getAccountBalance: function (accountNumber) {
                if (!accountNumber) {
                    return this.getAccountNumber().then(function (data) {
                        return this.getAccountBalanceData(data.accountNumber);
                    }.bind(this));
                } else {
                    return this.getAccountBalanceData(accountNumber);
                }
            },

            getAccountBalanceData: function  (accountNumber) {
                var deferred = $q.defer();
                var url = ConfigurationFac.getBaseServiceUrl() + '/uwt/v1/users/'+ accountNumber +'/balance';

                $http.get(url, {
                    headers: {
                        'Cache-Control': 'no-cache',
                        'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
                        'Pragma': 'no-cache'
                    }
                }).success(function (response) {
                    deferred.resolve(response);
                }).error(function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            },


            getAccountNumber: function () {
                var deferred = $q.defer();
                var url = ConfigurationFac.getBaseServiceUrl() + '/usa/v2/session/context';

                $http.get(url, {
                    headers: {
                        'Cache-Control': 'no-cache',
                        'If-Modified-Since': 'Mon, 26 Jul 1997 05:00:00 GMT',
                        'Pragma': 'no-cache'
                    }
                }).success(function (response) {
                    deferred.resolve(response);
                }).error(function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            },

            getVideoCountInfo: function () {
                var deferred = $q.defer();
                var url = '/ajax/video/id/user';

                $http.get(url).success(function (response) {
                    deferred.resolve(response);
                }).error(function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            },

            updateAccountBalance: function() {
                var deferred = $q.defer();

                this.getAccountBalance($rootScope && $rootScope.user && $rootScope.user.accountNumber).then(function (response) {

                    if ((response && response.balance === 0) || (response && response.balance && !isNaN(response.balance))) {
                        $rootScope.accountBalanceNumber = response.balance;
                        $rootScope.accountBalance = $filter("currency")(response.balance, "$");
                        $rootScope.$broadcast("accountBalance_changed");
                    }

                    deferred.resolve(response);
                }, function (response) {
                    deferred.reject(response);
                });

                return deferred.promise;
            }
        };

        var CommunicationsPreferencesFac = {
            _getApiUrl: function (contextName, serviceEndpoint) {
                return "/" + contextName + "/api/v1.0/" + serviceEndpoint;
            },

            _getCommunicationsPreferences: function() {
                var url = CommunicationsPreferencesFac._getApiUrl('deposit', "subscriptionsPreferences");
                var deferred = $q.defer();
                var context = JSON.stringify(ConfigurationFac.getApplicationContext());

                $http.get(url, {
                        headers: {
                            'x-tvgcontext': context
                        }
                    }
                ).then(function (response) {
                        if (response.data && response.data.status === 'success') {
                            deferred.resolve(response.data);
                        } else {
                            deferred.reject(response.data);
                        }
                    }, function (e) {
                        deferred.reject(e.data);
                    });

                return deferred.promise;
            },

            _getSubscriptions: function() {
                var deferred = $q.defer();
                var url = [ConfigurationFac.getServiceApiUrl('uam'), '/subscriptions/email'].join('');

                $http.get(url, {})
                    .success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function (response) {
                        deferred.reject(response);
                    });

                return deferred.promise;
            },

            _setSubscriptions: function (email, postData) {
                var deferred = $q.defer();
                var url = [ConfigurationFac.getServiceApiUrl('uam'), '/subscriptions/email/', email].join('');

                $http.put(url, postData, {})
                    .success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function (response) {
                        deferred.reject(response);
                    });

                return deferred.promise;
            },

            _changeCommunicationsPreferences: function(emailAddress, item) {
                var url = CommunicationsPreferencesFac._getApiUrl('deposit', "subscriptionsPreferences");
                var deferred = $q.defer();
                var context = JSON.stringify(ConfigurationFac.getApplicationContext());

                var postData = {
                    emailAddress: emailAddress,
                    publicationId: item.ID,
                    enabled: item.Enabled
                };

                $http.post(url, postData, {
                        headers: {
                            'x-tvgcontext': context
                        }
                    }
                ).then(function (response) {
                        if (response.data && response.data.status === 'success') {
                            deferred.resolve(response.data);
                        } else {
                            deferred.reject(response.data);
                        }
                    }, function (e) {
                        deferred.reject(e.data);
                    });

                return deferred.promise;
            }
        };

        var userPreferencesFac = {
             setRequestBetConfirmation: function (isConfirmed) {
                var deferred = $q.defer();

                if (_.isBoolean(isConfirmed) === false) {
                    deferred.reject('Error: isConfirmed must be a boolean value.');
                } else {

                    var betConfirm = (isConfirmed == true) ? 1 : 0;

                    if($rootScope.activeFeatures.useUamPreferencesBetslip) {
                        var preference = PreferencesEntityBuilder()
                            .withDescription('show_bet_confirm')
                            .withMetadata(betConfirm)
                            .build();

                        PreferencesFac.updatePreferences(preference).then(function() {
                            deferred.resolve();
                        }, function() {
                            deferred.reject('Error: failed to updatePreferences.');
                        });

                    } else {
                        var prefObj = PreferencesCookieFac.getPreferences();
                        prefObj.show_bet_confirm = betConfirm;
                        PreferencesCookieFac.updatePreferences(prefObj)
                            .then(function(isConfirmed) {
                                deferred.resolve(isConfirmed);
                            }, function() {
                                deferred.reject('Error: failed to updatePreferences.');
                            });
                    }
                }

                return deferred.promise;
        }
    };

        return {
            pollBalance: BalanceFac.pollBalance,
            stopPollingBalance: BalanceFac.stopPollingBalance,
            getAccountBalance: BalanceFac.getAccountBalance,
            getAccountNumber: BalanceFac.getAccountNumber,
            getAccountBalanceData: BalanceFac.getAccountBalanceData,
            getVideoCountInfo: BalanceFac.getVideoCountInfo,
            updateAccountBalance: BalanceFac.updateAccountBalance,
            getCommunicationsPreferences: CommunicationsPreferencesFac._getCommunicationsPreferences,
            changeCommunicationsPreferences: CommunicationsPreferencesFac._changeCommunicationsPreferences,
            setRequestBetConfirmationPreference: userPreferencesFac.setRequestBetConfirmation,
            getSubscriptions: CommunicationsPreferencesFac._getSubscriptions,
            setSubscriptions: CommunicationsPreferencesFac._setSubscriptions
        };
    }

    UserProfileSvc.$inject = [
        '$http',
        '$q',
        '$rootScope',
        'poller',
        '$filter',
        'ConfigurationFac',
        'PreferencesCookieFac',
        'PreferencesFac'
    ];

    return UserProfileSvc;
});

